import { forwardRef, type InputHTMLAttributes } from "react";

export type DatePickerProps = Omit<InputHTMLAttributes<HTMLInputElement>, "type"> & {
  label?: string;
  error?: string;
  type?: "date" | "datetime-local" | "time";
};

export const DatePicker = forwardRef<HTMLInputElement, DatePickerProps>(
  ({ label, error, type = "date", className = "", id, disabled, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, "-");

    return (
      <div className={`flex flex-col gap-1.5 ${className}`}>
        {label && (
          <label htmlFor={inputId} className="text-sm font-medium text-content-secondary">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          type={type}
          disabled={disabled}
          className={`
            w-full px-4 py-2 rounded-lg bg-surface-800 border text-white
            placeholder-content-muted transition-colors duration-200
            focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent
            disabled:opacity-50 disabled:cursor-not-allowed
            ${error ? "border-error-500" : "border-surface-700 hover:border-surface-600"}
          `}
          style={{ colorScheme: "dark" }}
          {...props}
        />
        {error && <p className="text-sm text-error-500">{error}</p>}
      </div>
    );
  },
);

DatePicker.displayName = "DatePicker";
